import React from "react";
import {
    ActivityIndicator,
    Pressable,
    StyleSheet,
    Text,
    View
} from "react-native";
import { MessageSchema } from "../../../realm/schema";
import {
    black30,
    black90,
    color_333333,
    color_main,
    white
} from "../../../assets/style/colors";
import { ImageView } from "../../../components/ImageView";
import { ChatPropsEvent } from "../ChatInput";
import { delMsgByCid } from "../../../store/ChatStore";
import { MessageType } from "../../../constants/types";
import { PickerResult } from "../../../utils/PicOrCameraManager";
import RNFS from "react-native-fs";
import { showToast } from "../../../components/Toast";
// import { MediaManager } from "../../../utils/MediaManager";
import ReadIcon from "../../../assets/svg/ic_msg_read.svg"
import UNReadIcon from "../../../assets/svg/ic_msg_unread.svg"


type TextPopMenuProps = {
    translate?: string
    isSelf: boolean;
}

export const TextPopMenu: React.FC<TextPopMenuProps> = ({ isSelf, translate }) => {
    // 确保 translate 是有效的非空字符串
    // 使用更严格的检查，避免数字 0、false 等 falsy 值被误判
    if (translate == null || typeof translate !== 'string' || translate.trim().length === 0) {
        return null;
    }
    
    // 再次确保 translate 是字符串且不为空
    const displayText = String(translate).trim();
    if (displayText.length === 0) {
        return null;
    }
    
    return (
        <View style={{
            flexDirection: "row",
            paddingHorizontal: 12,
            paddingVertical: 10, alignItems: 'center',
            marginTop: 12
        }}>
            <View style={{
                backgroundColor: black30,
                start: 0,
                end: 0,
                top: 0,
                height: 0.5,
                position: 'absolute'
            }} />
            <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
                <Text style={{ color: black90 }}>{displayText}</Text>
            </View>
        </View>
    );
}
const ReadCountStatusRender = (props: {
    uid: number;
    msg: MessageSchema,
    handleDel(item: MessageSchema): void,
    submitMsg: (e: ChatPropsEvent) => void
    submitMediaMsg: (result: PickerResult[]) => void
}) => {
    // 只对“我发的消息”显示状态
    const isSelf = props.msg?.sender === props.uid;
    if (!isSelf) return <></>;

    const sty = [chatViewStyles.singleIcon, { width: 20, height: 20 }];

    // 发送中 -> 转圈
    if (props.msg.send_statue === '0') {
        return <ActivityIndicator size="small" color={color_main} />;
    }

    function submitMediaMsg(path: string) {
        if (!path) {
            showToast && showToast('文件不存在');
            return;
        }
        RNFS.exists(path).then(exists => {
            if (!exists) {
                showToast && showToast('文件不存在');
                return;
            }
            const w = Number(props.msg.meta.width ?? '0');
            const h = Number(props.msg.meta.height ?? '0');
            const mimeType = props.msg.meta.mimeType ?? '';
            // 文档类型重试支持
            let type: 'photo' | 'video' | 'doc' = 'doc';
            if (props.msg.type === MessageType.IMAGE) type = 'photo';
            else if (props.msg.type === MessageType.VIDEO) type = 'video';
            props.submitMediaMsg([{ width: w, height: h, path, type, mimeType, fileName: props.msg.meta.name, fileSize: Number(props.msg.meta.size) }]);
        });
    }

    function reSubmitMsg() {
        props.handleDel(props.msg);
        setTimeout(() => {
            delMsgByCid(props.msg.tid, props.msg.cid, props.msg.mid, props.msg.sender).then(() => {
                // 优先用本地路径重试
                if (props.msg.upload_path && props.msg.upload_path.length > 0) {
                    submitMediaMsg(props.msg.upload_path);
                } else if (props.msg.content && props.msg.content.length > 0) {
                    // 兜底：content 有内容才允许直接重发
                    const c: ChatPropsEvent = {
                        content: props.msg.content,
                        type: props.msg.type,
                        atUids: props.msg.atUids,
                        meta: props.msg.meta,
                    };
                    props.submitMsg(c);
                } else {
                    showToast && showToast('文件不存在');
                }
            });
        }, 500);
    }

    // 发送失败 -> 重发按钮
    if (props.msg.send_statue === '1') {
        return (
            <ImageView
                imgStyle={sty}
                onClick={reSubmitMsg}
                source={require("../../../assets/image/msg_resend.png")}
            />
        );
    }

    // 只要“有人已读”就显示双勾（且消息有 mid）
    const hasMid = (props.msg.mid?.length ?? 0) > 0;
    const anyRead = hasMid && (props.msg.readCnt ?? 0) >= 1;

    // 媒体消息与文本用不同的图标资源
    const isMedia = props.msg.type === MessageType.IMAGE || props.msg.type === MessageType.VIDEO;
    const icon = isMedia
        ? (anyRead
            ? <ReadIcon />   // 双勾
            : <UNReadIcon />) // 单勾/未读
        : (anyRead
            ? <ReadIcon />        // 双勾
            : <UNReadIcon />);    // 单勾/未读

    return icon;
};

export const ReadCountStatus = React.memo(ReadCountStatusRender, (prevProps, nextProps) => {
    return prevProps === nextProps
})

const chatViewStyles = StyleSheet.create({
    emojiTextView: {
        display: "flex",
        flexDirection: "row",
        paddingHorizontal: 12,
        flexWrap: "wrap"
    },
    emoji: {
        width: 20,
        height: 20
    },
    readContent: {
        width: 36,
        height: 16,
        borderRadius: 8,
        borderWidth: 1.5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    readContentText: {
        fontSize: 10,
    },
    singleStatus: {
        position: "relative",
        width: 18,
        height: 18,
        borderWidth: 1.5,
        borderRadius: 9
    },
    singleIcon: {
        transform: [{ translateX: 1 }]
    },

    popover: {
        backgroundColor: color_333333,
        padding: 15,
        width: "70%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    popoverText: {
        display: "flex",
        color: white,
        fontSize: 12,
        fontWeight: "500",
        fontFamily: '',
    },

    talkView: {
        width: 260,
        // height: 155,
        backgroundColor: "#F1F1F4",
        borderRadius: 4,
        fontSize: 13,
        fontWeight: "400",
        fontFamily: '',
        color: "#666666"
    },
    talkViewTitle: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#333333",
        lineHeight: 32,
        fontFamily: '',
        paddingHorizontal: 12,
        marginBottom: 0
    },
    talkViewContent: {
        minHeight: 48,
        paddingHorizontal: 12,
        lineHeight: 24,
        overflow: "hidden"
    },
    talkViewContentText: {
        lineHeight: 30,
        height: 30,
        overflow: "hidden"
    },
    talkViewFooter: {
        height: 32,
        lineHeight: 32,
        paddingHorizontal: 12,
        borderTopWidth: 1,
        borderColor: "#D5D9DF"
    },
    talkViewFooterText: {
        height: 32,
        lineHeight: 32
    },
    container: {
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000"
    }
});
